export default function PoliceStatisticsDetails() {
  return (
    <div>
      <div className="police-bg bg-image">
        <div className="gap-spacer"></div>
        <div className="page-title mobile-center-title top-cap-outlines">
          <h1>Morrisville Borough Police</h1>
        </div>
        {/*Start Main Content*/}
        <div className="police-center-container mid-side-outlines">
          {/*Start Police Sub-Menu*/}
          <div className="police-sub-menu">
            <div className="logo"></div>
            <input className="menu-btn" type="checkbox" id="menu-btn"></input>
            <label className="menu-icon" for="menu-btn">
              <i className="fa-solid fa-bars"></i>&nbsp;Police Sub-Menu
            </label>
            <ul className="menu">
              <li>
                <a href="/police">General</a>
              </li>
              <li>
                <a href="https://bucks.crimewatchpa.com/morrisvillepd/34776">
                  CrimeWatch&nbsp;
                  <i className="fa-solid fa-arrow-up-right-from-square"></i>
                </a>
              </li>
              <li>
                <a href="/police/documents">Documents</a>
              </li>
              <li>
                <a href="/police/jobs">Jobs</a>
              </li>
              <li>
                <a href="/police/personnel">Personnel</a>
              </li>
              <li>
                <a href="/police/resources">Resources</a>
              </li>
              <li>
                <a href="https://bucks.crimewatchpa.com/morrisvillepd/34776/submit-tip">
                  Submit-A-Tip&nbsp;
                  <i className="fa-solid fa-arrow-up-right-from-square"></i>
                </a>
              </li>
              <li>
                <a href="/police/statistics">Statistics</a>
              </li>
            </ul>
          </div>
          {/*End Police Sub-Menu*/}
        </div>
        <div className="police-center-container mid-side-outlines ">
          <div className="police-960-col-100p">
            <h4>Monthly Crime Reports</h4>

            {/* Accordion Start - Crime Stats */}
            <div className="container accordion-container">
              <div className="accordion" id="CrimeStatsAccordion">
                {/* Item Start - 2026 */}
                <div className="stacked-accordion">
                  <h2 className="accordion-header">
                    <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2026">
                      <div>
                        <i className="fa-solid fa-caret-right fa-xl"></i>
                      </div>
                      <div>
                        <b className="howdoi-accordion-title">&nbsp;2026</b>
                      </div>
                    </button>
                  </h2>
                  <div id="collapse2026" className="accordion-collapse collapse show" data-bs-parent="#CrimeStatsAccordion">
                    <div className="accordion-body-no-sides">
                      <div className="police-stats-year">
                        <div className="police-stats-month">
                          <a href="../docs/police/2026-01-MBPD-CrimeStats.pdf">
                            Jan.
                            <br />
                            2026
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2026-02-MBPD-CrimeStats.pdf">
                            Feb.
                            <br />
                            2026
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2026-03-MBPD-CrimeStats.pdf">
                            Mar.
                            <br />
                            2026
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2026-04-MBPD-CrimeStats.pdf">
                            Apr.
                            <br />
                            2026
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>

                        <div className="police-stats-month">
                          <a href="../docs/police/2026-05-MBPD-CrimeStats.pdf">
                            May
                            <br />
                            2026
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>

                        <div className="police-stats-month">
                          <a href="../docs/police/2026-06-MBPD-CrimeStats.pdf">
                            Jun.
                            <br />
                            2026
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>

                        <div className="police-stats-month"><a href="../docs/police/2026-07-MBPD-CrimeStats.pdf">Jul.<br/>2026<br/><i className="fa-solid fa-file-pdf fa-xl"></i></a></div>
<div className="police-stats-month"><a href="../docs/police/2026-08-MBPD-CrimeStats.pdf">Aug.<br/>2026<br/><i className="fa-solid fa-file-pdf fa-xl"></i></a></div>
                        {/*
                        <div className="police-stats-month"><a href="../docs/police/2026-05-MBPD-CrimeStats.pdf">May<br/>2026<br/><i className="fa-solid fa-file-pdf fa-xl"></i></a></div>
                        
                        <div className="police-stats-month"><a href="../docs/police/2026-06-MBPD-CrimeStats.pdf">Jun.<br/>2026<br/><i className="fa-solid fa-file-pdf fa-xl"></i></a></div>
                        <div className="police-stats-month"><a href="../docs/police/2026-07-MBPD-CrimeStats.pdf">Jul.<br/>2026<br/><i className="fa-solid fa-file-pdf fa-xl"></i></a></div>
                        <div className="police-stats-month"><a href="../docs/police/2026-08-MBPD-CrimeStats.pdf">Aug.<br/>2026<br/><i className="fa-solid fa-file-pdf fa-xl"></i></a></div>
                        <div className="police-stats-month"><a href="../docs/police/2026-09-MBPD-CrimeStats.pdf">Sep.<br/>2026<br/><i className="fa-solid fa-file-pdf fa-xl"></i></a></div>
                        <div className="police-stats-month"><a href="../docs/police/2026-10-MBPD-CrimeStats.pdf">Oct.<br/>2026<br/><i className="fa-solid fa-file-pdf fa-xl"></i></a></div>
                        <div className="police-stats-month"><a href="../docs/police/2026-11-MBPD-CrimeStats.pdf">Nov.<br/>2026<br/><i className="fa-solid fa-file-pdf fa-xl"></i></a></div>
                        <div className="police-stats-month"><a href="../docs/police/2026-12-MBPD-CrimeStats.pdf">Dec.<br/>2026<br/><i className="fa-solid fa-file-pdf fa-xl"></i></a></div>
*/}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Item Finish */}

                {/* Item Start - 2025 */}
                <div className="stacked-accordion">
                  <h2 className="accordion-header">
                    <button className="accordion-button caret-off collapsed lightblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2025">
                      <div>
                        <i className="fa-solid fa-caret-right fa-xl"></i>
                      </div>
                      <div>
                        <b className="howdoi-accordion-title">&nbsp;2025</b>
                      </div>
                    </button>
                  </h2>
                  <div id="collapse2025" className="accordion-collapse collapse " data-bs-parent="#CrimeStatsAccordion">
                    <div className="accordion-body-no-sides">
                      <div className="police-stats-current-year">
                        <div className="police-stats-month">
                          <a href="../docs/police/2025-01-MBPD-CrimeStats.pdf">
                            Jan.
                            <br />
                            2025
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2025-02-MBPD-CrimeStats.pdf">
                            Feb.
                            <br />
                            2025
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2025-03-MBPD-CrimeStats.pdf">
                            Mar.
                            <br />
                            2025
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2025-04-MBPD-CrimeStats.pdf">
                            Apr.
                            <br />
                            2025
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2025-05-MBPD-CrimeStats.pdf">
                            May
                            <br />
                            2025
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2025-06-MBPD-CrimeStats.pdf">
                            Jun.
                            <br />
                            2025
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2025-07-MBPD-CrimeStats.pdf">
                            Jul.
                            <br />
                            2025
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2025-08-MBPD-CrimeStats.pdf">
                            Aug.
                            <br />
                            2025
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2025-09-MBPD-CrimeStats.pdf">
                            Sep.
                            <br />
                            2025
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2025-10-MBPD-CrimeStats.pdf">
                            Oct.
                            <br />
                            2025
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2025-11-MBPD-CrimeStats.pdf">
                            Nov.
                            <br />
                            2025
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2025-12-MBPD-CrimeStats.pdf">
                            Dec.
                            <br />
                            2025
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        {/*
                    
                        <div className="police-stats-month"><a href="../docs/police/2025-10-MBPD-CrimeStats.pdf">Oct.<br/>2025<br/><i className="fa-solid fa-file-pdf fa-xl"></i></a></div>
                        <div className="police-stats-month"><a href="../docs/police/2025-11-MBPD-CrimeStats.pdf">Nov.<br/>2025<br/><i className="fa-solid fa-file-pdf fa-xl"></i></a></div>
                        <div className="police-stats-month"><a href="../docs/police/2025-12-MBPD-CrimeStats.pdf">Dec.<br/>2025<br/><i className="fa-solid fa-file-pdf fa-xl"></i></a></div>
                        */}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Item Finish */}

                {/* Item Start - 2024 */}
                <div className="stacked-accordion">
                  <h2 className="accordion-header">
                    <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2024">
                      <div>
                        <i className="fa-solid fa-caret-right fa-xl"></i>
                      </div>
                      <div>
                        <b className="howdoi-accordion-title">&nbsp;2024</b>
                      </div>
                    </button>
                  </h2>
                  <div id="collapse2024" className="accordion-collapse collapse" data-bs-parent="#CrimeStatsAccordion">
                    <div className="accordion-body-no-sides">
                      <div className="police-stats-year">
                        <div className="police-stats-month">
                          <a href="../docs/police/2024-01-MBPD-CrimeStats.pdf">
                            Jan.
                            <br />
                            2024
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2024-02-MBPD-CrimeStats.pdf">
                            Feb.
                            <br />
                            2024
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2024-03-MBPD-CrimeStats.pdf">
                            Mar.
                            <br />
                            2024
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2024-04-MBPD-CrimeStats.pdf">
                            Apr.
                            <br />
                            2024
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2024-05-MBPD-CrimeStats.pdf">
                            May
                            <br />
                            2024
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2024-06-MBPD-CrimeStats.pdf">
                            Jun.
                            <br />
                            2024
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2024-07-MBPD-CrimeStats.pdf">
                            Jul.
                            <br />
                            2024
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2024-08-MBPD-CrimeStats.pdf">
                            Aug.
                            <br />
                            2024
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2024-09-MBPD-CrimeStats.pdf">
                            Sep.
                            <br />
                            2024
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2024-10-MBPD-CrimeStats.pdf">
                            Oct.
                            <br />
                            2024
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2024-11-MBPD-CrimeStats.pdf">
                            Nov.
                            <br />
                            2024
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2024-12-MBPD-CrimeStats.pdf">
                            Dec.
                            <br />
                            2024
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Item Finish */}

                {/* Item Start - 2023 */}
                <div className="stacked-accordion">
                  <h2 className="accordion-header">
                    <button className="accordion-button caret-off collapsed lightblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2023">
                      <div>
                        <i className="fa-solid fa-caret-right fa-xl"></i>
                      </div>
                      <div>
                        <b className="howdoi-accordion-title">&nbsp;2023</b>
                      </div>
                    </button>
                  </h2>
                  <div id="collapse2023" className="accordion-collapse collapse" data-bs-parent="#CrimeStatsAccordion">
                    <div className="accordion-body-no-sides">
                      <div className="police-stats-year">
                        <div className="police-stats-month">
                          <a href="../docs/police/2023-01-MBPD-CrimeStats.pdf">
                            Jan.
                            <br />
                            2023
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2023-02-MBPD-CrimeStats.pdf">
                            Feb.
                            <br />
                            2023
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2023-03-MBPD-CrimeStats.pdf">
                            Mar.
                            <br />
                            2023
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2023-04-MBPD-CrimeStats.pdf">
                            Apr.
                            <br />
                            2023
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2023-05-MBPD-CrimeStats.pdf">
                            May
                            <br />
                            2023
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2023-06-MBPD-CrimeStats.pdf">
                            Jun.
                            <br />
                            2023
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2023-07-MBPD-CrimeStats.pdf">
                            Jul.
                            <br />
                            2023
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2023-08-MBPD-CrimeStats.pdf">
                            Aug.
                            <br />
                            2023
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2023-09-MBPD-CrimeStats.pdf">
                            Sep.
                            <br />
                            2023
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2023-10-MBPD-CrimeStats.pdf">
                            Oct.
                            <br />
                            2023
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2023-11-MBPD-CrimeStats.pdf">
                            Nov.
                            <br />
                            2023
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2023-12-MBPD-CrimeStats.pdf">
                            Dec.
                            <br />
                            2023
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Item Finish */}

                {/* Item Start - 2022 */}
                <div className="stacked-accordion">
                  <h2 className="accordion-header">
                    <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2022">
                      <div>
                        <i className="fa-solid fa-caret-right fa-xl"></i>
                      </div>
                      <div>
                        <b className="howdoi-accordion-title">&nbsp;2022</b>
                      </div>
                    </button>
                  </h2>
                  <div id="collapse2022" className="accordion-collapse collapse" data-bs-parent="#CrimeStatsAccordion">
                    <div className="accordion-body-no-sides">
                      <div className="police-stats-year">
                        <div className="police-stats-month">
                          <a href="../docs/police/2022-01-MBPD-CrimeStats.pdf">
                            Jan.
                            <br />
                            2022
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2022-02-MBPD-CrimeStats.pdf">
                            Feb.
                            <br />
                            2022
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2022-03-MBPD-CrimeStats.pdf">
                            Mar.
                            <br />
                            2022
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2022-04-MBPD-CrimeStats.pdf">
                            Apr.
                            <br />
                            2022
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2022-05-MBPD-CrimeStats.pdf">
                            May
                            <br />
                            2022
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2022-06-MBPD-CrimeStats.pdf">
                            Jun.
                            <br />
                            2022
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2022-07-MBPD-CrimeStats.pdf">
                            Jul.
                            <br />
                            2022
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2022-08-MBPD-CrimeStats.pdf">
                            Aug.
                            <br />
                            2022
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2022-09-MBPD-CrimeStats.pdf">
                            Sep.
                            <br />
                            2022
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2022-10-MBPD-CrimeStats.pdf">
                            Oct.
                            <br />
                            2022
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2022-11-MBPD-CrimeStats.pdf">
                            Nov.
                            <br />
                            2022
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2022-12-MBPD-CrimeStats.pdf">
                            Dec.
                            <br />
                            2022
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Item Finish */}

                {/* Item Start - 2021 */}
                <div className="stacked-accordion">
                  <h2 className="accordion-header">
                    <button className="accordion-button caret-off collapsed lightblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2021">
                      <div>
                        <i className="fa-solid fa-caret-right fa-xl"></i>
                      </div>
                      <div>
                        <b className="howdoi-accordion-title">&nbsp;2021</b>
                      </div>
                    </button>
                  </h2>
                  <div id="collapse2021" className="accordion-collapse collapse" data-bs-parent="#CrimeStatsAccordion">
                    <div className="accordion-body-no-sides">
                      <div className="police-stats-year">
                        <div className="police-stats-month">
                          <a href="../docs/police/2021-01-MBPD-CrimeStats.pdf">
                            Jan.
                            <br />
                            2021
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2021-02-MBPD-CrimeStats.pdf">
                            Feb.
                            <br />
                            2021
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2021-03-MBPD-CrimeStats.pdf">
                            Mar.
                            <br />
                            2021
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2021-04-MBPD-CrimeStats.pdf">
                            Apr.
                            <br />
                            2021
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2021-05-MBPD-CrimeStats.pdf">
                            May
                            <br />
                            2021
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2021-06-MBPD-CrimeStats.pdf">
                            Jun.
                            <br />
                            2021
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2021-07-MBPD-CrimeStats.pdf">
                            Jul.
                            <br />
                            2021
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2021-08-MBPD-CrimeStats.pdf">
                            Aug.
                            <br />
                            2021
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2021-09-MBPD-CrimeStats.pdf">
                            Sep.
                            <br />
                            2021
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2021-10-MBPD-CrimeStats.pdf">
                            Oct.
                            <br />
                            2021
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2021-11-MBPD-CrimeStats.pdf">
                            Nov.
                            <br />
                            2021
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2021-12-MBPD-CrimeStats.pdf">
                            Dec.
                            <br />
                            2021
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Item Finish */}

                {/* Item Start - 2020 */}
                <div className="stacked-accordion">
                  <h2 className="accordion-header">
                    <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2020">
                      <div>
                        <i className="fa-solid fa-caret-right fa-xl"></i>
                      </div>
                      <div>
                        <b className="howdoi-accordion-title">&nbsp;2020</b>
                      </div>
                    </button>
                  </h2>
                  <div id="collapse2020" className="accordion-collapse collapse" data-bs-parent="#CrimeStatsAccordion">
                    <div className="accordion-body-no-sides">
                      <div className="police-stats-year">
                        <div className="police-stats-month">
                          <a href="../docs/police/2020-01-MBPD-CrimeStats.pdf">
                            Jan.
                            <br />
                            2020
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2020-02-MBPD-CrimeStats.pdf">
                            Feb.
                            <br />
                            2020
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2020-03-MBPD-CrimeStats.pdf">
                            Mar.
                            <br />
                            2020
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2020-04-MBPD-CrimeStats.pdf">
                            Apr.
                            <br />
                            2020
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2020-05-MBPD-CrimeStats.pdf">
                            May
                            <br />
                            2020
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2020-06-MBPD-CrimeStats.pdf">
                            Jun.
                            <br />
                            2020
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2020-07-MBPD-CrimeStats.pdf">
                            Jul.
                            <br />
                            2020
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2020-08-MBPD-CrimeStats.pdf">
                            Aug.
                            <br />
                            2020
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2020-09-MBPD-CrimeStats.pdf">
                            Sep.
                            <br />
                            2020
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2020-10-MBPD-CrimeStats.pdf">
                            Oct.
                            <br />
                            2020
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2020-11-MBPD-CrimeStats.pdf">
                            Nov.
                            <br />
                            2020
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2020-12-MBPD-CrimeStats.pdf">
                            Dec.
                            <br />
                            2020
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Item Finish */}

                {/* Item Start - 2019 */}
                <div className="stacked-accordion">
                  <h2 className="accordion-header">
                    <button className="accordion-button caret-off collapsed lightblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2019">
                      <div>
                        <i className="fa-solid fa-caret-right fa-xl"></i>
                      </div>
                      <div>
                        <b className="howdoi-accordion-title">&nbsp;2019</b>
                      </div>
                    </button>
                  </h2>
                  <div id="collapse2019" className="accordion-collapse collapse" data-bs-parent="#CrimeStatsAccordion">
                    <div className="accordion-body-no-sides">
                      <div className="police-stats-year">
                        <div className="police-stats-month">
                          <a href="../docs/police/2019-01-MBPD-CrimeStats.pdf">
                            Jan.
                            <br />
                            2019
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2019-02-MBPD-CrimeStats.pdf">
                            Feb.
                            <br />
                            2019
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2019-03-MBPD-CrimeStats.pdf">
                            Mar.
                            <br />
                            2019
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2019-04-MBPD-CrimeStats.pdf">
                            Apr.
                            <br />
                            2019
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2019-05-MBPD-CrimeStats.pdf">
                            May
                            <br />
                            2019
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2019-06-MBPD-CrimeStats.pdf">
                            Jun.
                            <br />
                            2019
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2019-07-MBPD-CrimeStats.pdf">
                            Jul.
                            <br />
                            2019
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2019-08-MBPD-CrimeStats.pdf">
                            Aug.
                            <br />
                            2019
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2019-09-MBPD-CrimeStats.pdf">
                            Sep.
                            <br />
                            2019
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2019-10-MBPD-CrimeStats.pdf">
                            Oct.
                            <br />
                            2019
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2019-11-MBPD-CrimeStats.pdf">
                            Nov.
                            <br />
                            2019
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2019-12-MBPD-CrimeStats.pdf">
                            Dec.
                            <br />
                            2019
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Item Finish */}

                {/* Item Start - 2018 */}
                <div className="stacked-accordion">
                  <h2 className="accordion-header">
                    <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2018">
                      <div>
                        <i className="fa-solid fa-caret-right fa-xl"></i>
                      </div>
                      <div>
                        <b className="howdoi-accordion-title">&nbsp;2018</b>
                      </div>
                    </button>
                  </h2>
                  <div id="collapse2018" className="accordion-collapse collapse" data-bs-parent="#CrimeStatsAccordion">
                    <div className="accordion-body-no-sides">
                      <div className="police-stats-year">
                        <div className="police-stats-month">
                          <a href="../docs/police/2018-01-MBPD-CrimeStats.pdf">
                            Jan.
                            <br />
                            2018
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2018-02-MBPD-CrimeStats.pdf">
                            Feb.
                            <br />
                            2018
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2018-03-MBPD-CrimeStats.pdf">
                            Mar.
                            <br />
                            2018
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2018-04-MBPD-CrimeStats.pdf">
                            Apr.
                            <br />
                            2018
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2018-05-MBPD-CrimeStats.pdf">
                            May
                            <br />
                            2018
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2018-06-MBPD-CrimeStats.pdf">
                            Jun.
                            <br />
                            2018
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2018-07-MBPD-CrimeStats.pdf">
                            Jul.
                            <br />
                            2018
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2018-08-MBPD-CrimeStats.pdf">
                            Aug.
                            <br />
                            2018
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2018-09-MBPD-CrimeStats.pdf">
                            Sep.
                            <br />
                            2018
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2018-10-MBPD-CrimeStats.pdf">
                            Oct.
                            <br />
                            2018
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2018-11-MBPD-CrimeStats.pdf">
                            Nov.
                            <br />
                            2018
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2018-12-MBPD-CrimeStats.pdf">
                            Dec.
                            <br />
                            2018
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Item Finish */}

                {/* Item Start - 2017 */}
                <div className="stacked-accordion">
                  <h2 className="accordion-header">
                    <button className="accordion-button caret-off collapsed lightblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2017">
                      <div>
                        <i className="fa-solid fa-caret-right fa-xl"></i>
                      </div>
                      <div>
                        <b className="howdoi-accordion-title">&nbsp;2017</b>
                      </div>
                    </button>
                  </h2>
                  <div id="collapse2017" className="accordion-collapse collapse" data-bs-parent="#CrimeStatsAccordion">
                    <div className="accordion-body-no-sides">
                      <div className="police-stats-year">
                        <div className="police-stats-month">
                          <a href="../docs/police/2017-01-MBPD-CrimeStats.pdf">
                            Jan.
                            <br />
                            2017
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2017-02-MBPD-CrimeStats.pdf">
                            Feb.
                            <br />
                            2017
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2017-03-MBPD-CrimeStats.pdf">
                            Mar.
                            <br />
                            2017
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2017-04-MBPD-CrimeStats.pdf">
                            Apr.
                            <br />
                            2017
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2017-05-MBPD-CrimeStats.pdf">
                            May
                            <br />
                            2017
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2017-06-MBPD-CrimeStats.pdf">
                            Jun.
                            <br />
                            2017
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2017-07-MBPD-CrimeStats.pdf">
                            Jul.
                            <br />
                            2017
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2017-08-MBPD-CrimeStats.pdf">
                            Aug.
                            <br />
                            2017
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2017-09-MBPD-CrimeStats.pdf">
                            Sep.
                            <br />
                            2017
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2017-10-MBPD-CrimeStats.pdf">
                            Oct.
                            <br />
                            2017
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2017-11-MBPD-CrimeStats.pdf">
                            Nov.
                            <br />
                            2017
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                        <div className="police-stats-month">
                          <a href="../docs/police/2017-12-MBPD-CrimeStats.pdf">
                            Dec.
                            <br />
                            2017
                            <br />
                            <i className="fa-solid fa-file-pdf fa-xl"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Item Finish */}

                  {/* Item Start - 2016 */}
                  <div className="stacked-accordion">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapse2016">
                        <div>
                          <i className="fa-solid fa-caret-right fa-xl"></i>
                        </div>
                        <div>
                          <b className="howdoi-accordion-title">&nbsp;2016</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapse2016" className="accordion-collapse collapse" data-bs-parent="#CrimeStatsAccordion">
                      <div className="accordion-body-no-sides">
                        <div className="police-stats-year">
                          <div className="police-stats-month">
                            <a href="../docs/police/2016-01-MBPD-CrimeStats.pdf">
                              Jan.
                              <br />
                              2016
                              <br />
                              <i className="fa-solid fa-file-pdf fa-xl"></i>
                            </a>
                          </div>
                          <div className="police-stats-month">
                            <a href="../docs/police/2016-02-MBPD-CrimeStats.pdf">
                              Feb.
                              <br />
                              2016
                              <br />
                              <i className="fa-solid fa-file-pdf fa-xl"></i>
                            </a>
                          </div>
                          <div className="police-stats-month">
                            <a href="../docs/police/2016-03-MBPD-CrimeStats.pdf">
                              Mar.
                              <br />
                              2016
                              <br />
                              <i className="fa-solid fa-file-pdf fa-xl"></i>
                            </a>
                          </div>
                          <div className="police-stats-month">
                            <a href="../docs/police/2016-04-MBPD-CrimeStats.pdf">
                              Apr.
                              <br />
                              2016
                              <br />
                              <i className="fa-solid fa-file-pdf fa-xl"></i>
                            </a>
                          </div>
                          <div className="police-stats-month">
                            <a href="../docs/police/2016-05-MBPD-CrimeStats.pdf">
                              May
                              <br />
                              2016
                              <br />
                              <i className="fa-solid fa-file-pdf fa-xl"></i>
                            </a>
                          </div>
                          <div className="police-stats-month">
                            <a href="../docs/police/2016-06-MBPD-CrimeStats.pdf">
                              Jun.
                              <br />
                              2016
                              <br />
                              <i className="fa-solid fa-file-pdf fa-xl"></i>
                            </a>
                          </div>
                          <div className="police-stats-month">
                            <a href="../docs/police/2016-07-MBPD-CrimeStats.pdf">
                              Jul.
                              <br />
                              2016
                              <br />
                              <i className="fa-solid fa-file-pdf fa-xl"></i>
                            </a>
                          </div>
                          <div className="police-stats-month">
                            <a href="../docs/police/2016-08-MBPD-CrimeStats.pdf">
                              Aug.
                              <br />
                              2016
                              <br />
                              <i className="fa-solid fa-file-pdf fa-xl"></i>
                            </a>
                          </div>
                          <div className="police-stats-month">
                            <a href="../docs/police/2016-09-MBPD-CrimeStats.pdf">
                              Sep.
                              <br />
                              2016
                              <br />
                              <i className="fa-solid fa-file-pdf fa-xl"></i>
                            </a>
                          </div>
                          <div className="police-stats-month">
                            <a href="../docs/police/2016-10-MBPD-CrimeStats.pdf">
                              Oct.
                              <br />
                              2016
                              <br />
                              <i className="fa-solid fa-file-pdf fa-xl"></i>
                            </a>
                          </div>
                          <div className="police-stats-month">
                            <a href="../docs/police/2016-11-MBPD-CrimeStats.pdf">
                              Nov.
                              <br />
                              2016
                              <br />
                              <i className="fa-solid fa-file-pdf fa-xl"></i>
                            </a>
                          </div>
                          <div className="police-stats-month">
                            <a href="../docs/police/2016-12-MBPD-CrimeStats.pdf">
                              Dec.
                              <br />
                              2016
                              <br />
                              <i className="fa-solid fa-file-pdf fa-xl"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/* Accordion Finish - Crime Stats */}
            </div>
          </div>
        </div>

        <div className="page-footer bottom-cap-outlines">&nbsp;</div>
        <div className="gap-spacer"></div>
        <div className="gap-spacer"></div>
      </div>
    </div>
  );
}
